import {
  LENS_CENTER,
  LensNoCircle,
  useThreeEventTarget,
} from "@faro-lotv/app-component-toolbox";
import { useEffect } from "react";

/**
 * This hook is used by the tools that pick precise 3D points, to set the proper
 * mouse cursor while the user is picking.
 *
 * @param active Whether the lens cursor should be applied
 */
export function useLensCursor(active: boolean): void {
  const domElement = useThreeEventTarget();

  useEffect(() => {
    if (active) {
      const oldCursor = domElement.style.cursor;
      domElement.style.cursor = `url("${LensNoCircle}") ${LENS_CENTER} ${LENS_CENTER},auto`;

      return () => {
        domElement.style.cursor = oldCursor;
      };
    }
  }, [active, domElement]);
}
